<div class="c-d-flex c-flex-column desi-breakdown-form-confirm-modal">
  <div class="c-d-flex c-flex-column message-wrapper">
    <h3 class="c-header-md heading">{{ title }}</h3>
    <p class="c-text-lg">{{ message }}</p>
  </div>
  <div class="c-d-flex c-flex-wrap c-justify-end">
    <button class="c-btn c-text-lg rounded" (click)="closeModal()">{{ cancelBtnText }}</button>
    <button class="c-btn c-btn-primary c-text-lg rounded" (click)="leavePage()">{{ leaveBtnText }}</button>
  </div>
</div>